import Autolinker from 'autolinker';
import DOMPurify from 'isomorphic-dompurify';
import './link-policy';

const ALLOWED_TAGS = ['p', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a', 'br'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeRichText(html: string): string {
  const linked = Autolinker.link(html, {
    urls: true,
    email: true,
    phone: true,
    newWindow: false,
    stripPrefix: false,
    stripTrailingSlash: false,
  });
  return DOMPurify.sanitize(linked, {ALLOWED_TAGS, ALLOWED_ATTR});
}
